 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		46: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		46: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"8":"DeprecatedStyles","11":"EnhancedStyles","12":"app-components-Workflow-WorkflowContainer","13":"app-components-bibs-BibPage-BibPageContainer","14":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","15":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","16":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","17":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","18":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","19":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","20":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","21":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","22":"app-components-bibs-subpages-CommentPage-CommentPageContainer","23":"app-components-bibs-subpages-MarcPage-MarcPageContainer","24":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","25":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","26":"app-components-bibs-subpages-VideoPage-VideoPageContainer","27":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","28":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","29":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","30":"app-components-borrowing-fines-Fines-FinesContainer","31":"app-components-borrowing-holds-Holds-HoldsContainer","32":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","33":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","34":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","35":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","36":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","37":"app-components-events-EventsSearchPage-EventsSearchPageContainer","38":"app-components-events-MyEventsPage-MyEventsPageContainer","39":"app-components-locations-LocationsPage-LocationsPage","40":"app-components-search-Search-SearchContainer","41":"app-components-search-SearchPrintList-SearchPrintListContainer","42":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","43":"app-components-shelves-Shelf-ShelfContainer","44":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","45":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"a17e982376e3eccd921b","1":"4c15d274f9a531007d71","2":"20c14724b3962ef1077c","3":"2b1f25b7a87d13c2a57d","4":"4ff4e087cb2c93f095bb","5":"aab0c644bc505d84a7e0","6":"48d6f208062147d27513","7":"35e645cd45fbe7630222","8":"3370216912a2d138af57","9":"cf6476b15aba649d84d3","10":"99555319258f7552d329","11":"0d3518ef7214295073f4","12":"c88cfd561df75d785984","13":"8e9b145c05f19b8692d9","14":"d9dcac2b9c5615493383","15":"a2a8c8bde53dbc366c45","16":"1dff3c393462795e4849","17":"00941253b59e58800012","18":"889a4244db6b85c8ef07","19":"1f7f9018b4311610f460","20":"a8a52ede9531c1125904","21":"636474ac7d0f0b990642","22":"ece2707c7bd6a11adf36","23":"0150e1105f16feaf24dc","24":"ce0f9c091111fd4af1cb","25":"48cf554fd1ea7e503036","26":"53f69cfc784dc68bfa98","27":"74dce7ee8b13a4c6b023","28":"a72cb019bd5c511bdb47","29":"fe862d912abe7d992ac3","30":"4d33934e364847bdc973","31":"e89c7dc8ac20568032d0","32":"036ca09c7e9e556bba73","33":"d6fe7fb516b558c15979","34":"ae5d5d0ebad583e9d2b8","35":"f111db0f5e7d52200754","36":"10f5659cd71c17b715b1","37":"317e7a1e9b30a0693598","38":"afa7e2bb196f70ba4b07","39":"14db60c64eadb836a7b0","40":"06e4f3acfbf66bc76367","41":"bf8e684e015d6eaffe8f","42":"cf53b941f50196a47e5a","43":"0c963d505c2e91c464f4","44":"36c59183435963569d53","45":"11020f5e48e09f2b7d56","47":"1cd65a67930fcc6a0469","48":"0ced3d73545ec6f4a763","49":"bda2ab378c66f42c41b9","50":"77b628cda618e39b38e2","51":"e03ce628915fc7da8864","52":"74646402fc21d4edc3b0","53":"fcaf4d3d1521bb80b2ad","54":"b6deeb5343219b7a995d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"8":"DeprecatedStyles","11":"EnhancedStyles","12":"app-components-Workflow-WorkflowContainer","13":"app-components-bibs-BibPage-BibPageContainer","14":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","15":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","16":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","17":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","18":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","19":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","20":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","21":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","22":"app-components-bibs-subpages-CommentPage-CommentPageContainer","23":"app-components-bibs-subpages-MarcPage-MarcPageContainer","24":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","25":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","26":"app-components-bibs-subpages-VideoPage-VideoPageContainer","27":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","28":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","29":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","30":"app-components-borrowing-fines-Fines-FinesContainer","31":"app-components-borrowing-holds-Holds-HoldsContainer","32":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","33":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","34":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","35":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","36":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","37":"app-components-events-EventsSearchPage-EventsSearchPageContainer","38":"app-components-events-MyEventsPage-MyEventsPageContainer","39":"app-components-locations-LocationsPage-LocationsPage","40":"app-components-search-Search-SearchContainer","41":"app-components-search-SearchPrintList-SearchPrintListContainer","42":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","43":"app-components-shelves-Shelf-ShelfContainer","44":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","45":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"a17e982376e3eccd921b","1":"4c15d274f9a531007d71","2":"20c14724b3962ef1077c","3":"2b1f25b7a87d13c2a57d","4":"4ff4e087cb2c93f095bb","5":"aab0c644bc505d84a7e0","6":"48d6f208062147d27513","7":"35e645cd45fbe7630222","8":"3370216912a2d138af57","9":"cf6476b15aba649d84d3","10":"99555319258f7552d329","11":"0d3518ef7214295073f4","12":"c88cfd561df75d785984","13":"8e9b145c05f19b8692d9","14":"d9dcac2b9c5615493383","15":"a2a8c8bde53dbc366c45","16":"1dff3c393462795e4849","17":"00941253b59e58800012","18":"889a4244db6b85c8ef07","19":"1f7f9018b4311610f460","20":"a8a52ede9531c1125904","21":"636474ac7d0f0b990642","22":"ece2707c7bd6a11adf36","23":"0150e1105f16feaf24dc","24":"ce0f9c091111fd4af1cb","25":"48cf554fd1ea7e503036","26":"53f69cfc784dc68bfa98","27":"74dce7ee8b13a4c6b023","28":"a72cb019bd5c511bdb47","29":"fe862d912abe7d992ac3","30":"4d33934e364847bdc973","31":"e89c7dc8ac20568032d0","32":"036ca09c7e9e556bba73","33":"d6fe7fb516b558c15979","34":"ae5d5d0ebad583e9d2b8","35":"f111db0f5e7d52200754","36":"10f5659cd71c17b715b1","37":"317e7a1e9b30a0693598","38":"afa7e2bb196f70ba4b07","39":"14db60c64eadb836a7b0","40":"06e4f3acfbf66bc76367","41":"bf8e684e015d6eaffe8f","42":"cf53b941f50196a47e5a","43":"0c963d505c2e91c464f4","44":"36c59183435963569d53","45":"11020f5e48e09f2b7d56","47":"1cd65a67930fcc6a0469","48":"0ced3d73545ec6f4a763","49":"bda2ab378c66f42c41b9","50":"77b628cda618e39b38e2","51":"e03ce628915fc7da8864","52":"74646402fc21d4edc3b0","53":"fcaf4d3d1521bb80b2ad","54":"b6deeb5343219b7a995d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2322);
